import cloneDeep from 'lodash/cloneDeep'
import leadOptions from './_treatment-helper'

import template from './_treatment-form.pug'

export default Vue.extend({
  template: template(),
  props: {
    leadProviderOptions: {
      type: Array,
      default: () => ([])
    },
    initData: {
      type: Object,
      default: () => ({})
    },
    errors: {
      type: Object,
      default: () => ({})
    },
    mode: {
      type: String,
      validator: value => ['new', 'edit'].includes(value)
    }
  },
  data() {
    return {
      data: {},
      LeadsOptions: leadOptions
    }
  },
  computed: {
    title() {
      return this.t(`${this.mode}Title`)
    },
    saveButtonText() {
      return this.t(`${this.mode}Button`)
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.data = cloneDeep(this.initData)
    },
    close() {
      this.$emit('close')
    },
    submit() {
      this.$emit('submit', this.data)
    },
    t(key, options = {}) {
      return this.$t(`campaigns.show.validations.tabs.treatment.${key}`, options)
    }
  }
})
